module.exports = __webpack_public_path__ + "static/media/Resourceful.ce54c8b8.png";